export enum PriceComponentType {
  SEAT = 'seat',
  AGENT = 'agent',
}

export const PRICE_COMPONENT_PRODUCT_NAME: Readonly<Record<PriceComponentType, string>> = {
  [PriceComponentType.SEAT]: 'backoffice.enums.price_component_product.seat',
  [PriceComponentType.AGENT]: 'backoffice.enums.price_component_product.agent',
};

export const PRICE_COMPONENT_LABEL: Readonly<Record<PriceComponentType, string>> = {
  [PriceComponentType.SEAT]: 'backoffice.enums.price_component.seat',
  [PriceComponentType.AGENT]: 'backoffice.enums.price_component.agent',
};
